import { z } from 'zod';
import {
  dateDmySchema,
  nonEmptyTrimmed,
  optionalTrimmed,
  phoneSchema,
} from './primitives.js';

const yesNo = z.enum(['yes', 'no'], { required_error: 'Please answer yes or no' });

export const cisAssessmentSchema = z
  .object({
    jobTitle: nonEmptyTrimmed('Job title', 120),
    duration: nonEmptyTrimmed('Duration in current role', 60),
    qualifications: optionalTrimmed(1000),
    roleDescription: nonEmptyTrimmed('Role description', 2000),
    assignmentsInLast12Months: z.coerce
      .number({ invalid_type_error: 'Enter a number' })
      .int('Enter a whole number')
      .min(0, 'Must be 0 or more')
      .max(200, 'Value seems too high'),

    employmentBenefits: yesNo,
    submitsSelfAssessment: yesNo,
    coversOwnExpenses: yesNo,
    canDeclineWork: yesNo,
    multipleClients: yesNo,
    decidesHowWorkDone: yesNo,
    subjectToSupervision: yesNo,
    understandsSubstitution: yesNo,

    providesOwnEquipment: yesNo,
    equipmentDetails: optionalTrimmed(1000),

    receivesTraining: yesNo,
    trainingDetails: optionalTrimmed(1000),

    declarationAccepted: z
      .boolean()
      .refine((v) => v === true, 'You must accept the declaration'),
    fullName: nonEmptyTrimmed('Full name', 160),
    date: dateDmySchema,
    contactNumber: phoneSchema,
  })
  .superRefine((data, ctx) => {
    if (data.providesOwnEquipment === 'no' && !data.equipmentDetails) {
      ctx.addIssue({
        path: ['equipmentDetails'],
        code: z.ZodIssueCode.custom,
        message: 'Provide details of the equipment arrangement',
      });
    }
    if (data.receivesTraining === 'yes' && !data.trainingDetails) {
      ctx.addIssue({
        path: ['trainingDetails'],
        code: z.ZodIssueCode.custom,
        message: 'Provide details of the training received',
      });
    }
  });

export type CisAssessment = z.infer<typeof cisAssessmentSchema>;
